angular.module('cerberus.admin')
    .controller('ListConfigCtrl', function ListConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                          DesignerUtilityService, PagesDesignerListService,
                                                          pageObjectConfigService, ViewsService, vizListService, WidgetsService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');

        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.formFieldsArray = [];
        vm.idArray = _.compact(_.map(filters, 'id'));
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        /* LODASH Version 4 ONLY */
        //vm.editorTools = _.reject(vm.textEditorOptions.tools, ['name', 'nimViewHtml']);
        /* LODASH Version 3 & 4 Compatibility Mode */
        vm.editorTools = _.reject(vm.textEditorOptions.tools, function(r){return r.name === 'nimViewHtml';});

        vm.vizDict = vizListService.vizDictionary();
        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/list/list-data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/list/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);
        vm.listViewTemplatePresets = PagesDesignerListService.listViewTemplatePresets();

        vm.templateChanged = function(){
            vm.temp.params.variant = 'none';
            var fields = vm.temp.viz.settings.dataSource.schema.model.fields;
            if(vm.temp.viz.settings.template === 'contacts'){
                fields.title.from = '';
                fields.description.from = '';
            }
            else {
                fields.name.from = '';
                fields.email.from = '';
            }
        };

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;
        vm.preventSpace = DesignerUtilityService.preventSpace;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);
        vm.resetRecordFields = resetRecordFields;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });
            
            vm.loadFormFields(pageObject.viz.widgetId);

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(/*colField*/){ /* There was some code here, but it's gone now */ }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }

            if(_.get(vm.temp.params, 'uploadFilename.modelId') === colField){
                delete vm.temp.params.uploadFilename;
            }

            if(_.get(vm.temp.params, 'uploadImageField.modelId') === colField){
                delete vm.temp.params.uploadImageField;
            }
        }

        function resetRecordFields(){
            vm.temp.params.uploadFilename = null;
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    })
;